export default __webpack_public_path__ + "static/media/Person3.1f10200f.jpeg";